/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} ArchiveInputs */

const en_archive = /** @type {(inputs: ArchiveInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Archive`)
};

const es_archive = /** @type {(inputs: ArchiveInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Archivar`)
};

/**
* | output |
* | --- |
* | "Archive" |
*
* @param {ArchiveInputs} inputs
* @param {{ locale?: "en" | "es" }} options
* @returns {LocalizedString}
*/
export const archive = /** @type {((inputs?: ArchiveInputs, options?: { locale?: "en" | "es" }) => LocalizedString) & import('../runtime.js').MessageMetadata<ArchiveInputs, { locale?: "en" | "es" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_archive(inputs)
	return es_archive(inputs)
});